import { http } from 'transport';

export default http;



// WEBPACK FOOTER //
// ./src/shared/utils/http.js